import { faEllipsis, faEye, faPen, faTrash, faPrint } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@shared/components/ui/dropdown-menu';

import { Cart } from '../../models/Cart';

type LabelSize = 'small' | 'large';

interface DropdownActionsProps {
  cart: Cart;
  onEdit?: (cart: Cart) => void;
  onDelete?: (cart: Cart) => void;
  onAdjust?: (cart: Cart) => void;
  onPrint?: (cart: Cart, size: LabelSize) => void;
  onToggleLock?: (cart: Cart) => void;
  onViewProducts?: (cart: Cart) => void;
}

export const DropdownActions = ({ cart, onEdit, onDelete, onPrint, onViewProducts }: DropdownActionsProps) => {
  const { t } = useTranslation('cartsModule');

  // 🎯 Verificar si el carrito tiene productos
  const hasProducts = cart.stock_location_carts && cart.stock_location_carts.length > 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="hover:bg-muted rounded-md" data-testid={`dropdown-trigger-${cart.id}`}>
          <FontAwesomeIcon icon={faEllipsis} className="text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-44 border-card-border" data-testid={`dropdown-content-${cart.id}`}>
        {/* 🎯 Opción de ver productos (solo si hay productos) */}
        {/* 🎯 Opción de ver productos (solo si hay productos) */}
        {hasProducts && onViewProducts && (
          <DropdownMenuItem data-testid={`dropdown-view-products-${cart.id}`} onClick={() => onViewProducts(cart)}>
            <FontAwesomeIcon icon={faEye} className="mr-2 w-3.5" />
            {t('table.view_products')}
          </DropdownMenuItem>
        )}

        {onPrint && (
          <DropdownMenuSub>
            <DropdownMenuSubTrigger data-testid={`dropdown-print-${cart.id}`}>
              <FontAwesomeIcon icon={faPrint} className="mr-2 w-3.5" />
              {t('table.print')}
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
              <DropdownMenuItem data-testid={`dropdown-print-small-${cart.id}`} onClick={() => onPrint(cart, 'small')}>
                {t('modal.label.size_small')}
              </DropdownMenuItem>
              <DropdownMenuItem data-testid={`dropdown-print-large-${cart.id}`} onClick={() => onPrint(cart, 'large')}>
                {t('modal.label.size_large')}
              </DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        )}

        {onEdit && (
          <DropdownMenuItem data-testid={`dropdown-edit-${cart.id}`} onClick={() => onEdit(cart)}>
            <FontAwesomeIcon icon={faPen} className="mr-2 w-3.5" />
            {t('table.edit')}
          </DropdownMenuItem>
        )}

        {onDelete && (
          <DropdownMenuItem data-testid={`dropdown-delete-${cart.id}`} onClick={() => onDelete(cart)}>
            <FontAwesomeIcon icon={faTrash} className="mr-2 w-3.5" />
            {t('table.delete')}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
